import { Input, message } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as AssembleBlackSvg } from "@/commons/icons/panel-icon/assemble-black.svg";
import { graphicStore } from "@/commons/store/graphic-store";
import { LayerType } from "@/commons/enums/layer-type";
import { HVAC_SUB_CONTROL } from "@/passets/hvac-engine/enums/hvac-sub-control";
import { HVAC_SIGNAL } from "@/passets/hvac-engine/enums/hvac-signal";
import { HVAC_CTRL_TYPE } from "@/passets/hvac-engine/enums/hvac-control-type";
import { ENTITY_TYPE, Cylinder, CylinderT, Point } from "pytha";
import { Vector3 } from "three";
import { getSpecialPrimitiveLayerUuid } from "@/commons/utils/layer-utils";
import { HvacVortexFanT } from "@/passets/hvac-engine/models/HvacVortexFanT";


function generateVortexFanBlock(name: string, diameter: number, height: number, layerUuid: string): HvacVortexFanT {
    let cylinder = new Cylinder(new Point(0, 0, 0), diameter / 2, height, new Vector3(0, 0, 1));
    let cylinderT = new CylinderT(cylinder);
    let entities = [cylinderT];
    let hvacVortexFanT: HvacVortexFanT = new HvacVortexFanT(new Point(0, 0, 0), entities, name, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
    hvacVortexFanT.layerUuid = layerUuid;
    return hvacVortexFanT;
}

export default function HavcDeviceVortexFanPanel() {
    const { projectId, modelUuid } = useParams();
    const MODEL_NAME = "漩涡风机";
    const [diameter, setDiameter] = useState<number>(0);            // 漩涡风机直径
    const [height, setHeight] = useState<number>(0);
    const [offset, setOffset] = useState<number>(0);                // 相对标高的偏移

    const assemble = () => {
        if (!diameter) {
            message.warning("请输入直径");
            return;
        }

        if (!height) {
            message.warning("请输入高度");
            return;
        }

        getSpecialPrimitiveLayerUuid(projectId, modelUuid, LayerType.VORTEXFAN).then((layerUuid: string) => {
            // 激活布置构件的二级控制器
            const currentCmdControl = graphicStore.extraContext.getCurrentViewEditor().cmdControl;
            if (currentCmdControl) {
                graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
            }

            let data = {
                name: MODEL_NAME,
                comType: LayerType.VORTEXFAN,
            }
            let hvacVortexFanT: HvacVortexFanT = generateVortexFanBlock(MODEL_NAME, diameter, height, layerUuid);

            currentCmdControl.activateSubCommandControl(HVAC_SUB_CONTROL.ADDHVACDEVICECONTROL.name);
            graphicStore.extraContext.listeners.getSignal(HVAC_SIGNAL.initHvacDeviceControl).dispatch(data, ENTITY_TYPE.HAVC, hvacVortexFanT, offset);
        });
    }

    return (
        <>
            <div className="row compact">
                <div className="label">直径(mm):</div>
                <Input
                    size='small'
                    value={diameter}
                    className="input-box"
                    placeholder='宽度1(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setDiameter(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">高度(mm):</div>
                <Input
                    size='small'
                    value={height}
                    className="input-box"
                    placeholder='高度(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setHeight(parseFloat(value));
                    }}
                />
            </div>
            <div className="row compact">
                <div className="label">相对标高偏移(mm):</div>
                <Input
                    size='small'
                    value={offset}
                    className="input-box"
                    placeholder='相对标高偏移(mm)'
                    onChange={(e) => {
                        let value: any = e.target.value;
                        if (value == null || value === "" || isNaN(value) || value <= 0) {
                            value = 1;
                        }
                        setOffset(parseFloat(value));
                    }}
                />
            </div>
            <div className='bottom-footer'>
                <div className="ope-btn">
                    <div className="insert-button" onClick={assemble}>
                        <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                        <div className="text">布置</div>
                    </div>
                </div>
            </div>
        </>
    )
}